import { render } from "./CreateOrDeleteCasino.vue?vue&type=template&id=8220a43e&scoped=true"
import script from "./CreateOrDeleteCasino.vue?vue&type=script&lang=js"
export * from "./CreateOrDeleteCasino.vue?vue&type=script&lang=js"

import "./CreateOrDeleteCasino.vue?vue&type=style&index=0&id=8220a43e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\javon\\mgs\\RabbitsfootOperatorApps\\adminpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8220a43e"]])

export default __exports__